import type { CSSProperties } from 'react';

export const omitUndefined = (obj: CSSProperties): CSSProperties =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
